import { parseURL } from './parse-url';

/**
 * Check if the current client application is hosted in the admin editor
 * @return {boolean}
 */
export const getIsEditor = () => {
	const search = parseURL(window.location.search).searchObject;
	return !!search.editor;
};
